<contacts-view-old
  [(value)]="value"
  [disabled]="disabled"
  [loading]="loading"
  [allowCreating]="allowCreating"
  [allowEditing]="allowEditing"
  [allowDeleting]="allowDeleting"
  [allowFilesDeleting]="allowFilesDeleting"
  [isModeration]="isModeration"
  [showFieldCounter]="showFieldCounter"
  [showFieldSeparator]="showFieldSeparator"
  [showFieldValue]="showFieldValue"
  [touched]="touched"
  [acceptFiles]="accept"
  [contactMaxLength]="contactMaxLength"
  [descriptionMaxLength]="descriptionMaxLength"
  (statusChange)="onStatusChange($event)"
></contacts-view-old>
